module.exports = __webpack_public_path__ + "static/media/add_image.7ee98cf9.png";